import getTotalPrices from "@lib/cart/getTotalPrices"
import { pluralize } from "@lib/pluralize"
import { useSliceContext } from "@components/SliceProvider"
import { formatBlockscanUrl } from "@/src/lib/formatBlockscanUrl"

export default function CartRecap() {
  const { appChainId, cart, hash } = useSliceContext()

  const { totalPriceEth, totalPriceUsdc } = getTotalPrices(cart)
  const quantity = cart.reduce((acc, el) => acc + el.quantity, 0)

  return (
    <div className="sl-mt-2 sl-mb-6 sl-text-sm sl-text-black">
      <div className="sl-flex sl-justify-between">
        <p>
          TOTAL ({quantity} {pluralize(quantity, "item")}){" "}
        </p>
        <p className="sl-font-bold sl-text-right ">
          {totalPriceEth > 0 &&
            `ETH ${Math.round(totalPriceEth * 1000) / 1000}`}
          {/* {totalPriceEth > 0 && totalPriceUsdc > 0 && <br />} */}
          {totalPriceEth > 0 && totalPriceUsdc > 0 && " + "}
          {totalPriceUsdc > 0 &&
            `USDC ${
              Math.round(
                (Math.floor(Number(totalPriceUsdc) / 10 ** 4) / 100) * 10
              ) / 10
            }`}
          {totalPriceEth === 0 && totalPriceUsdc === 0 && "Free"}
        </p>
      </div>
      {hash && (
        <p className="sl-text-right sl-mt-1">
          <a
            className="sl-highlight sl-text-muted-foreground sl-font-normal"
            href={`${formatBlockscanUrl(appChainId)}tx/${hash}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Onchain receipt
          </a>
        </p>
      )}
    </div>
  )
}
